import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IVariablesClient, VariablesClient } from "app/ApiClient";
import { LoadingState } from "types";
import { initialVariableStatsState } from "./variableStatsState";

const variablesClient: IVariablesClient = new VariablesClient(process.env.REACT_APP_API_URL);
export const getScalarVariableStats = createAsyncThunk(
  "variableStats/getScalarVariableStats",
  async (
    { projectId, variableName, versionId }: { projectId: number; versionId: string; variableName: string },
    { rejectWithValue },
  ) => {
    try {
      return await variablesClient.getScalarStats(projectId, versionId, variableName);
    } catch (error) {
      rejectWithValue(error);
    }
  },
);

export const getCategoricalVariableStats = createAsyncThunk(
  "variableStats/getCategoricalVariableStats",
  async (
    { projectId, variableName, versionId }: { projectId: number; versionId: string; variableName: string },
    { rejectWithValue },
  ) => {
    try {
      return await variablesClient.getCategoricalStats(projectId, versionId, variableName);
    } catch (error) {
      rejectWithValue(error);
    }
  },
);

const variableStatsSlice = createSlice({
  name: "variableStats",
  initialState: initialVariableStatsState,
  reducers: {
    resetVariableStats: () => initialVariableStatsState,
  },
  extraReducers: (builder) => {
    // getScalarVariableStats
    builder.addCase(getScalarVariableStats.pending, (state) => {
      state.scalarStats = null;
      state.loading = LoadingState.pending;
    });
    builder.addCase(getScalarVariableStats.fulfilled, (state, { payload }) => {
      state.scalarStats = payload;
      state.loading = LoadingState.succeed;
    });
    builder.addCase(getScalarVariableStats.rejected, (state) => {
      state.loading = LoadingState.failed;
    });

    // getCategoricalVariableStats
    builder.addCase(getCategoricalVariableStats.pending, (state) => {
      state.categoricalStats = null;
      state.loading = LoadingState.pending;
    });
    builder.addCase(getCategoricalVariableStats.fulfilled, (state, { payload }) => {
      state.categoricalStats = payload;
      state.loading = LoadingState.succeed;
    });
    builder.addCase(getCategoricalVariableStats.rejected, (state) => {      
      state.loading = LoadingState.failed;
    });
  },
});
export const { resetVariableStats } = variableStatsSlice.actions;
export default variableStatsSlice.reducer;
